import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IMetricDescriptionParams {
  id: string;
  description: string;
}

export class SetMetricDescriptionRequest extends Request<IMetricDescriptionParams, IResult> {
  constructor(params: IMetricDescriptionParams) {
    super('setMetricDescription', params);
  }
}
